jQuery(document).ready(function( $ ) {

    // Set global menu icon
    $( '.menu-globe > a' ).html( '<img src="' + theme.path + 'img/globe' + ($('.secondary-scheme').length ? '-alt' : '') + '.png">' );

    // Fetch body classes
    let body_classes = $( 'body' ).attr( 'class' ).split(' ');

    let language_class = '';
    // TODO find a better way to fetch the translatepress current language class
    body_classes.forEach( function( value, index ){
        if ( value.indexOf( 'translatepress-' ) >= 0) {
            language_class = value;
        }
    } );
    
    $('.menu-globe .sub-menu li.' + language_class).addClass('active-lang');

});